import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// routing
import router from 'routes';

// project imports
import ThemeCustomization from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import Notistack from 'ui-component/third-party/Notistack';
import Snackbar from 'ui-component/extended/Snackbar';

/**
 * Step 5 — the MP router is now mounted.
 *
 * Provider(store) + ConfigProvider are in index.tsx. PartnerAuthProvider +
 * PartnerLayout live inside the router subtree (PartnerRoutes). No JWTProvider /
 * Locales / geo-block — those are main-app concerns excluded from the MP app.
 */
const App = () => {
    return (
        <ThemeCustomization>
            <ToastContainer />
            <NavigationScroll>
                <Notistack>
                    <RouterProvider router={router} />
                    <Snackbar />
                </Notistack>
            </NavigationScroll>
        </ThemeCustomization>
    );
};

export default App;
